import { getLoggingChange } from './logging';
import { isSessionExpired } from './session';
import Logger from '../logger';

const onStatusChange = (oldStatus, newStatus) => {
    Logger.log(`onStatusChange: old=${oldStatus}, new=${newStatus}`);

    if (window.WC._localStorage.isPresent()) {
        window.WC.Closer.wasOpen = true;
    }

    if (!newStatus || oldStatus === newStatus) {
        return;
    }

    switch (newStatus) {
        case 'loggedIn':
            window.WC._localStorage.clearAll();
            break;
        case 'loggedOut':
            window.WC._localStorage.clearAll();
            window.WC.Closer.wasOpen = false;
            break;
    }

    window.WC._localStorage.set('userStatus', newStatus);
};

const updateUserStatus = () => {
    const currentUserStatus = window.WC._localStorage.get('userStatus');

    let newUserStatus;
    if (isSessionExpired()) {
        newUserStatus = window.WC._localStorage.set('userStatus', 'loggedOut');
    } else {
        newUserStatus = getLoggingChange(currentUserStatus);
    }

    onStatusChange(currentUserStatus, newUserStatus);
};

export { updateUserStatus };
